var React = require('react');

function ContentFastTracks (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-fast-tracks"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("polygon",{"points":"54.38 22.12 28.47 0 28.47 10.1 42.45 22.04 54.38 22.12","key":0}),React.createElement("polygon",{"points":"54.38 42.28 28.47 20.16 28.47 30.26 42.45 42.19 54.38 42.28","key":1}),React.createElement("polygon",{"points":"0 32.37 25.92 10.25 25.92 20.35 11.94 32.29 0 32.37","key":2}),React.createElement("polygon",{"points":"0 52.41 25.92 30.28 25.92 40.39 11.94 52.32 0 52.41","key":3})]))]);
}

ContentFastTracks.defaultProps = {"viewBox":"0 0 54.38 52.41"};

module.exports = ContentFastTracks;

ContentFastTracks.default = ContentFastTracks;
